export default __webpack_public_path__ + "1f50be7c209c0419677c98b00009ab25.pdf";